import React from 'react';
import { Modal } from 'src/components/new/modal/Modal';
import { ModalTitle } from 'src/components/new/modal/ModalTitle';
import { ModalContent } from 'src/components/new/modal/ModalContent';
import { ModalFooter } from 'src/components/new/modal/ModalFooter';
import { TextField } from 'src/components/new/inputs/TextField';

interface AddNewAdminUserProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  error: string;
}

const AddNewAdminUser: React.FC<AddNewAdminUserProps> = ({ open, onClose, onSubmit, onChange, value, error }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalTitle onClose={onClose}>Add New User</ModalTitle>
      <ModalContent>
        <TextField id="newUser" value={value} name="newUser" onChange={onChange} error={error} label="Email:" />
      </ModalContent>
      <ModalFooter onClose={onClose} closeText="Cancel" onSubmit={() => onSubmit()} submitText="Add" />
    </Modal>
  );
};

export default AddNewAdminUser;
